var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-732 -1840) translate(732 1840)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ksy3bmek4b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#71w0sc4gba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "71w0sc4gba",
    d: "M20.4 4.2c1.325 0 2.4 1.075 2.4 2.4v10.8c0 1.325-1.075 2.4-2.4 2.4H3.6c-1.325 0-2.4-1.075-2.4-2.4V6.6c0-1.325 1.075-2.4 2.4-2.4h16.8zm-9.72 4.08c-.53 0-.96.43-.96.96V15c0 .208.067.41.192.576.318.424.92.51 1.344.192l3.84-2.88c.049-.036.093-.077.134-.122l.058-.07c.318-.424.232-1.026-.192-1.344l-3.84-2.88c-.166-.125-.368-.192-.576-.192z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#272A32",
    mask: "url(#ksy3bmek4b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayer);
export default __webpack_public_path__ + "static/media/icon-player.912e2227b446b42562fcc3f1ac46e7e7.svg";
export { ForwardRef as ReactComponent };